/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <transition
  enter-active-class="animate__animated animate__fadeIn animate__delay-1s"
  leave-active-class="animate__animated animate__fadeOut">
    <section class="related-product" v-if="relatedProduct && relatedProduct.length">
      <b-container fluid>
        <b-row class="justify-content-center">
          <b-col md="11">
            <div class="section-title">
              <h3 class="title">{{$t('You should like also')}}</h3>
            </div>
            <div v-swiper:related="optRelatedProduct" class="related-product__slide">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(rel, index) in relatedProduct" :key="rel.sku">
                  <product-card :product="rel" :listIndex="index" @productClicked="$emit('productClicked', $event)"></product-card>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </transition>
</template>

<script>
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import ProductCard from 'theme/components/Product/ProductCard'
import { directive } from 'vue-awesome-swiper'

if (process.client) {
  require('swiper/css/swiper.css')
}

export default {
  name: 'RelatedProduct',
  props: {
    relatedProduct: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      optRelatedProduct: {
        slidesPerView: 4,
        spaceBetween: 30,
        allowTouchMove: true,
        pagination: {
          el: '.related-product .swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.related-product .swiper-button-next',
          prevEl: '.related-product .swiper-button-prev'
        },
        watchOverflow: true
      }
    }
  },
  directives: {
    swiper: directive
  },
  components: {
    ProductCard,
    AbsoluteLoader
  }
}
</script>
